module.exports = __webpack_public_path__ + "media/images/przedszkole3-a86d8a3dbfb3cc062476f2da722a99cc.png";